import React from "react";
import { Header, Button, Segment, Label, Grid, Card } from "semantic-ui-react";
import TemplateMain from "../../components/TemplateMain";
import logo from "../../assets/logo.png";
import CardSocial, { ICardSocial } from "../../components/CardSocial";

const socialCards: ICardSocial[] = [
    {
        nome: "teste",
        descricao: "teste",
        path: logo,
        roles: ["Admin", "GerenteS"]
    },
    {
        nome: "teste 2",
        descricao: "teste 2",
        path: logo,
        roles: ["Admin"]
    }
];

const Redes: React.FC = () => {
    const content = (
        <>
            <Header icon="comments" as="h1" content="Redes Sociais" dividing />
            <Grid textAlign="center">
                <Grid.Row>
                    <Header color="pink" content="Nos acompanhe nas redes sociais!" />
                </Grid.Row>
                <Grid.Row textAlign="center">
                    <Grid.Column>
                        <Button size="massive" href="https://www.facebook.com/poderfemininosemijoias" target="_blank" circular icon="facebook" color="facebook" />
                    </Grid.Column>
                    <Grid.Column>
                        <Button size="massive" href="https://www.instagram.com/poderfemininosemijoias/" target="_blank" circular icon="instagram" color="pink" />
                    </Grid.Column>
                    <Grid.Column>
                        <Button size="massive" href="https://www.linkedin.com/company/poder-feminino-semijoias/" target="_blank" circular icon="linkedin" color="linkedin" />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <Segment textAlign="center">
                <Label attached="top" color="pink" content="Aqui você pode baixar algumas imagens, para te ajudar na sua divulgação." />
                <Grid>
                    <Grid.Row>
                        <Grid.Column>
                            <Card.Group centered>
                                {socialCards.map((card) => (
                                    <CardSocial
                                        nome={card.nome}
                                        descricao={card.descricao}
                                        path={card.path}
                                        roles={card.roles}
                                    />
                                ))}
                            </Card.Group>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Segment>
        </>
    )
    return (
        <TemplateMain
            loading={false}
            content={content}
        />
    )
}
export default Redes;
